module.exports = __webpack_public_path__ + "static/media/howitwork4.efb81a77.jpg";